

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchLockData, fetchLockStatus } from 'shared/actions/lockerActions';

interface ILocked {
    lockedData: any;
    isLocked: boolean;
    isFetching: boolean;
}

const initialState = {
    lockedData: null,
    isLocked: false,
    isFetching: false
} as ILocked;

const LockerSlice = createSlice({
    name: 'lock',
    initialState,
    reducers: {
        setModerOrExpert(state, action: PayloadAction<boolean>) {
            // state.isModerOrExpert = action.payload;
        },
    },
    extraReducers: {
        [fetchLockStatus.fulfilled.toString()]: (state, action) => {
            state.isLocked = action.payload;
            state.isFetching = false;
        },
        [fetchLockStatus.rejected.toString()]: (state, action) => {
            state.isLocked = false
            state.isFetching = false;
        },
        [fetchLockStatus.pending.toString()]: (state, action) => {
            state.isLocked = false
            state.isFetching = true;
        },

        [fetchLockData.fulfilled.toString()]: (state, action) => {
            state.lockedData = action.payload;
            state.isFetching = false;
        },
        [fetchLockData.rejected.toString()]: (state, action) => {
            state.lockedData = false
            state.isFetching = false;
        },
        [fetchLockData.pending.toString()]: (state, action) => {
            state.lockedData = false
            state.isFetching = true;
        },
    }
});

export const { setModerOrExpert  } = LockerSlice.actions;
export const LockedSelector = (store: { lock: ILocked }): ILocked => store.lock;
export default LockerSlice;


import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchLockData, fetchLockStatus } from 'shared/actions/lockerActions';

interface ILocked {
    lockedData: any;
    isLocked: boolean;
    isFetching: boolean;
}

const initialState = {
    lockedData: null,
    isLocked: false,
    isFetching: false
} as ILocked;

const LockerSlice = createSlice({
    name: 'lock',
    initialState,
    reducers: {
        setModerOrExpert(state, action: PayloadAction<boolean>) {
            // state.isModerOrExpert = action.payload;
        },
    },
    extraReducers: {
        [fetchLockStatus.fulfilled.toString()]: (state, action) => {
            state.isLocked = action.payload;
            state.isFetching = false;
        },
        [fetchLockStatus.rejected.toString()]: (state, action) => {
            state.isLocked = false
            state.isFetching = false;
        },
        [fetchLockStatus.pending.toString()]: (state, action) => {
            state.isLocked = false
            state.isFetching = true;
        },

        [fetchLockData.fulfilled.toString()]: (state, action) => {
            state.lockedData = action.payload;
            state.isFetching = false;
        },
        [fetchLockData.rejected.toString()]: (state, action) => {
            state.lockedData = false
            state.isFetching = false;
        },
        [fetchLockData.pending.toString()]: (state, action) => {
            state.lockedData = false
            state.isFetching = true;
        },
    }
});

export const { setModerOrExpert  } = LockerSlice.actions;
export const LockedSelector = (store: { lock: ILocked }): ILocked => store.lock;
export default LockerSlice;
